/**
 * Method to query the DOM for a single element.
 *
 * @method dom
 */
var dom = function(selector, parent) {

  // If no parent is provided, use the document root
  parent = parent || document;

  // Query the DOM for the selector and return the element
  return parent.querySelector(selector);

};

/**
 * Method to query the DOM for elements.
 *
 * @method doms
 */
var doms = function(selector, parent) {

  // If no parent is provided, use the document root
  parent = parent || document;

  // Query the DOM for the selector and return the element(s)
  return parent.querySelectorAll(selector);

};

/**
 * Method to bind event handlers to DOM element events.
 *
 * @method bind
 */
var bind = function(elements, event, listener) {

  // Check if a node list of elements has been provided
  if (typeof(elements) === NodeList) {
    // Loop over elements to add event listeners
    elements.forEach(function(element) {
      element.addEventListener(event, listener);
    });
  } else {
    // Add event listener to element
    elements.addEventListener(event, listener);
  }

};
